import { render } from "./BackgrView.vue?vue&type=template&id=fc37f0c0&scoped=true"
import script from "./BackgrView.vue?vue&type=script&lang=js"
export * from "./BackgrView.vue?vue&type=script&lang=js"

import "./BackgrView.vue?vue&type=style&index=0&id=fc37f0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc37f0c0"]])

export default __exports__